import { render, staticRenderFns } from "./truckbed-slider.vue?vue&type=template&id=2c04ca9e&scoped=true"
import script from "./truckbed-slider.vue?vue&type=script&lang=js"
export * from "./truckbed-slider.vue?vue&type=script&lang=js"
import style0 from "./truckbed-slider.vue?vue&type=style&index=0&id=2c04ca9e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c04ca9e",
  null
  
)

export default component.exports